import { useEffect, useState } from "react";


export function useOneTimeLatch(inputSwitch: boolean) {
    const [latch, setLatch] = useState(false);

    useEffect(() => {
        if(inputSwitch && !latch)
            setLatch(true);
    }, [inputSwitch, latch]);

    return [latch, setLatch];
}